var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reference)?_c('div',{staticClass:"mb-md-5 mb-2"},[_c('div',{staticClass:"sub-title"},[_vm._v("Ga verder")]),_c('div',{staticClass:"link",on:{"click":_vm.select}},[_c('font-awesome-icon',{staticClass:"font-awesome-icon",attrs:{"icon":"tasks"}}),_vm._v(" "+_vm._s(_vm.reference)+"\n  ")],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }